import { Box, Fade, Grid2, Typography } from "@mui/material";
import React from "react";
import { useDashLayoutCtx } from "./DashLayoutCtxProvider";
import PropTypes from "prop-types";
import COLORS from "../../../constants/Colors";
import ProviderLogos from "../../../assets/images/provider_logos.png";
// import FlagBg from "../../../assets/images/flag_matrix_bg_small.jpg"

function DashSplitContainer({
  children,
  showAction = false,
  actionFunc = () => {},
  actionLabel = "Action",
  headingBgColor = COLORS.PRIMARY_GRAD,
  heading = "Heading",
}) {
  const { splitView, expandedView } = useDashLayoutCtx();
  const childrenArray = React.Children.toArray(children);
  const leftChild = childrenArray[0] || (
    <>No component supplied to split view.</>
  );
  const rightChild = childrenArray[1] || <></>;
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "calc(100% - 40px)",
          maxWidth: "1350px",
          // bgcolor: "grey",
          height: "100%",
          padding: "40px 20px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            height: "50px",
            mb: "20px",
          }}
        >
          <Box
            sx={{
              background: headingBgColor,
              // background: `url(${FlagBg})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              borderRadius: "4px",
              flexGrow: 1,
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              padding: "0 20px",
            }}
          >
            <Typography
              fontSize={"1.4rem"}
              fontWeight={700}
              color="white"
              sx={{
                userSelect: "none",
              }}
            >
              {heading}
            </Typography>
          </Box>

          {showAction && (
            <Box
              sx={{
                background: COLORS.PRIMARY_GRAD,
                borderRadius: "4px",
                ml: "20px",
                width: "190px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={actionFunc}
            >
              <Typography
                fontSize={"1.25rem"}
                fontWeight={600}
                color="white"
                sx={{
                  userSelect: "none",
                }}
              >
                {actionLabel}
              </Typography>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            // bgcolor: "red",
          }}
        >
          <Grid2
            container
            spacing={2.5}
            direction={"row"}
            sx={{
              height: "100%",
              width: "100%",
            }}
          >
            <Grid2
              size={splitView ? 6 : 12}
              sx={{
                flexGrow: 1,
                height: "calc(100vh - 190px)",
                background: "white",
                borderRadius: "4px",
                overflowY: "scroll",
                display: expandedView ? "none" : "block",
              }}
            >
              <Box
                sx={{
                  height: "calc(100vh - 190px)",
                  overflowY: "scroll",
                }}
              >
                {leftChild}
              </Box>
            </Grid2>
            <Grid2
              size={expandedView ? 12 : 6}
              sx={{
                flexGrow: 1,
                height: "calc(100vh - 190px)",
                display: splitView || expandedView ? "block" : "none",
                background: "white",
                borderRadius: "4px",
                overflow: "hidden",
              }}
            >
              <Fade in={splitView || expandedView} timeout={500}>
                <Box
                  sx={{
                    height: "calc(100vh - 190px)",
                    overflowY: "scroll",
                  }}
                >
                  {rightChild}
                </Box>
              </Fade>
            </Grid2>
          </Grid2>
        </Box>
        <Box
          sx={{
            height: "30px",
            mt: "10px",
            overflow: "hidden",
            display: "flex",
            flexDirection: "row",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <Typography
            fontSize={"0.9rem"}
            fontWeight={500}
            sx={{
              opacity: "0.6",
              mr: "20px",
            }}
          >
            Powered by
          </Typography>
          <Box
            sx={{
              height: "30px",
              width: "180px",
              overflow: "hidden",
              backgroundImage: `url(${ProviderLogos})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}

DashSplitContainer.propTypes = {
  showAction: PropTypes.bool,
  actionLabel: PropTypes.string,
  actionFunc: PropTypes.func,
  headingBgColor: PropTypes.string,
  heading: PropTypes.string,
};

export default DashSplitContainer;
